import React from 'react';
import PropTypes from 'prop-types';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@components/ui/tooltip';
import { cn } from '@lib/utils';

const TooltipWidget = ({
  children,
  title,
  content,
  startIcon,
  sideOffset,
  color = 'default',
  delayDuration = 0,
}) => {
  const StartIcon = startIcon || null;

  return (
    <Tooltip delayDuration={delayDuration}>
      <TooltipTrigger data-testid="tooltip-trigger" asChild>
        {children}
      </TooltipTrigger>
      <TooltipContent
        sideOffset={sideOffset}
        color={color}
        data-testid="tooltip-content"
      >
        <div className="pui-flex pui-justify-between pui-gap-2 ">
          {StartIcon && (
            <div className="pui-flex pui-shrink-0 pui-w-8 pui-h-8 pui-justify-center pui-shadow-x-small pui-items-center pui-p-1.5 pui-rounded-full pui-border pui-border-stroke-primary">
              <StartIcon
                className={cn('pui-w-4 pui-h-4 pui-text-text-white')}
              />
            </div>
          )}
          <div className="pui-flex pui-flex-col pui-gap-1">
            {title && (
              <h5 className="pui-font-semibold pui-text-label-sm">{title}</h5>
            )}
            <p className="pui-text-p-sm">{content}</p>
          </div>
        </div>
      </TooltipContent>
    </Tooltip>
  );
};

TooltipWidget.displayName = 'TooltipWidget';

TooltipWidget.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  startIcon: PropTypes.elementType,
  sideOffset: PropTypes.number,
  color: PropTypes.oneOf([
    'primary',
    'info',
    'success',
    'error',
    'warning',
    'default',
  ]),
  delayDuration: PropTypes.number,
};

export { TooltipWidget };
